import styles from "../FeedbackDialog.module.css";

interface WhatGetsSentProps {
  /** Verified email of the reporter, so they can see it is attached. */
  userEmail: string | null;
  /** Whether a reconciliation is loaded, which changes what is included. */
  hasRun: boolean;
  /** How many client log entries will travel. */
  logCount: number;
}

/**
 * The full list of what is collected, in plain language.
 *
 * This is not a legal notice, it is the thing that makes the collection
 * reasonable. The report carries the reporter's email, their route, their
 * browser and whatever the page has already logged - none of which they typed.
 * Somebody who cannot see what is being sent has to either trust it or not
 * report the bug, and enough people pick the second that it is worth the space.
 *
 * Closed by default: it answers a question rather than asking one, and a form
 * that opens with a disclosure reads as a form with something to disclose.
 */
export function WhatGetsSentView({ userEmail, hasRun, logCount }: WhatGetsSentProps) {
  return (
    <details className={styles.disclosure}>
      <summary>What gets sent with this</summary>
      <ul className={styles.disclosureList}>
        <li>What you typed above.</li>
        <li>Your name and email{userEmail ? `, ${userEmail}` : ""}, so we can ask you more.</li>
        <li>Which screen you were on, and which version of the app you have loaded.</li>
        <li>Your browser and window size.</li>
        <li>
          {logCount > 0
            ? `${logCount} technical message${logCount === 1 ? "" : "s"} the page recorded while you were working.`
            : "Any technical messages the page recorded. There are none right now."}
        </li>
        <li>
          {hasRun
            ? "How big the reconciliation on screen is - the settings you ran it with, and how many rows, orders and flags it produced."
            : "That no reconciliation is currently loaded."}
        </li>
      </ul>
      <p className={styles.disclosureNote}>
        No spreadsheet you uploaded is sent, and no vendor, purchase order, item or amount from
        it - only the counts above.
      </p>
    </details>
  );
}
